
export const onProductImageClick = (miniaturesWrapperElement) => {
    const image = miniaturesWrapperElement.querySelector('.product-detail');

    if (!image) return;
    miniaturesWrapperElement.classList.toggle('show-image')

    if (!image.getBoundingClientRect) return;
    const imageDimensions = image.getBoundingClientRect();

    if (image.classList.contains('product-detail--show-bottom') && imageDimensions.top + imageDimensions.height > window.innerHeight) {
        image.classList.remove('product-detail--show-bottom');
        image.classList.add('product-detail--show-top');
    } else if (image.classList.contains('product-detail--show-top') && imageDimensions.bottom + imageDimensions.height < window.innerHeight) {
        image.classList.remove('product-detail--show-top');
        image.classList.add('product-detail--show-bottom');
    }
}

const initProductImageCloseButtons = (miniaturesWrapperElements) => {
    for (let i = 0; i < miniaturesWrapperElements.length; i++) {
        const miniaturesWrapperElement = miniaturesWrapperElements[i];
        const closeProductImageElement = miniaturesWrapperElement.querySelector('.product-detail-close');

        if (!closeProductImageElement) return;
        
        closeProductImageElement.addEventListener('click', function(event) {
            miniaturesWrapperElement.classList.remove('show-image');
        });
    }
}

export const initFlyerMiniatures = () => {
    const miniaturesWrapperElements = document.getElementsByClassName('snapchat');

    if (miniaturesWrapperElements && miniaturesWrapperElements.length > 0) {
        // amp does not have getBoundingClientRect function
        const isAmp = !!!miniaturesWrapperElements[0].getBoundingClientRect;

        initProductImageCloseButtons(miniaturesWrapperElements);

        // on AMP we cannot check outside element click => only toggle image on click miniature
        if (isAmp) {
            for (let i = 0; i < miniaturesWrapperElements.length; i++) {
                const miniaturesWrapperElement = miniaturesWrapperElements[i];

                miniaturesWrapperElement.onclick = (event) => {
                    const isClickOnCloseBtn = event.target && event.target.classList.contains('product-detail-close');
                    if (!isClickOnCloseBtn) {
                        onProductImageClick(miniaturesWrapperElement);
                    }
                };
            }
        } else {
            document.onclick = (event) => {

                for (let i = 0; i < miniaturesWrapperElements.length; i++) {
                    const miniaturesWrapperElement = miniaturesWrapperElements[i];

                    const isProductImageShown = miniaturesWrapperElement.classList.contains('show-image');
                    const isClickOnMiniature = miniaturesWrapperElement.contains(event.target);

                    if (isClickOnMiniature) {
                        const isClickOnCloseBtn = event.target && event.target.classList.contains('product-detail-close');

                        if (!isClickOnCloseBtn) {
                            onProductImageClick(miniaturesWrapperElement);
                        }
                    } else if (!isClickOnMiniature && isProductImageShown) {
                        miniaturesWrapperElement.classList.remove('show-image') 
                    }
                }
            };
        }
    }
}
